import { useEffect } from 'react'
import { connectPusher, disconnectPusher } from 'services/pusherService'

export function useToasterNotifications(operatorId, addToast) {
  useEffect(() => {
    if (!operatorId) return

    connectPusher(operatorId, (notification) => {
      addToast({
        title: notification?.title || 'Nova notificação',
        message: notification?.message || '',
      })
    })

    return () => {
      disconnectPusher()
    }
  }, [operatorId, addToast])
}
